import React from "react";
import { Chip, ListSubheader, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import styles from "../../style.module.scss";
import network from "../../../../../actions/external/network";
import { toastr } from "react-redux-toastr";

class ListeMethodeAlternative extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      listeMaterielMethodesAlt: [],
      loading: true,
    };
  }
  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { t } = this.props;
    try {
      const [listeMaterielMethodesAlt] = await Promise.all([network.fetch("/api/demarches/listeMateriel")]);

      this.setState({
        listeMaterielMethodesAlt,
        loading: false,
      });
    } catch (error) {
      toastr.error(t("error", "Erreur"), t("admin.users.load-error", "Erreur lors du chargement des données"));
    }
  };
  render() {
    const { indicateur, sousRubriqueIndex, libelleEnglobantIndex, changeIndicateur } = this.props;
    const { listeMaterielMethodesAlt } = this.state;

    const valueRendered = (
      <TextField
        size={"small"}
        fullWidth={false}
        select
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 500,
                maxWidth: 700,
              },
            },
          },
          multiple: true,
          renderValue: (selected) => (
            <div className="d-flex flex-wrap">
              {selected.map((value) => {
                const libelle = listeMaterielMethodesAlt
                  .flatMap((m) => m.materiels)
                  .find((materiel) => materiel.code === value)?.libelle;
                return (
                  <Tooltip title={libelle ?? ""} key={value}>
                    <Chip key={value} label={libelle} className={styles.wrapperChip} />
                  </Tooltip>
                );
              })}
            </div>
          ),
        }}
        style={{ width: "25em" }}
        value={indicateur.valeur.value || []}
        onChange={(event) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: event.target.value.filter((i) => i !== undefined) } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      >
        {listeMaterielMethodesAlt
          .flatMap((listeMateriel) => [
            {
              type: "head",
              title: listeMateriel.libelleTypeMateriel,
            },
            ...listeMateriel.materiels.map((materiel) => ({
              type: "item",
              materiel,
            })),
          ])
          .map((elem, i) =>
            elem.type === "head" ? (
              <ListSubheader
                key={i}
                style={{ backgroundColor: "#f5f5f5", fontWeight: "bold", color: "rgba(0,0,0,0.87)" }}
              >
                {elem.title}
              </ListSubheader>
            ) : (
              <MenuItem key={i} value={elem.materiel.code}>
                {elem.materiel.libelle}
              </MenuItem>
            )
          )}
      </TextField>
    );

    return <React.Fragment>{valueRendered}</React.Fragment>;
  }
}

export default compose(withTranslation())(ListeMethodeAlternative);
